export default __webpack_public_path__ + "static/media/7.7b28ae21.jpg";